import { render, staticRenderFns } from "./historyincome.vue?vue&type=template&id=a2a1c018&scoped=true"
import script from "./historyincome.vue?vue&type=script&lang=js"
export * from "./historyincome.vue?vue&type=script&lang=js"
import style0 from "./historyincome.vue?vue&type=style&index=0&id=a2a1c018&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a1c018",
  null
  
)

export default component.exports